<div class="mg-country-selector">
  <mg-country
    [country]="$any('CAN')"
    [active]="value == 'CAN'"
    (click)="_setValue('CAN')"></mg-country>
  <mg-country
    [country]="$any('USA')"
    [active]="value == 'USA'"
    (click)="_setValue('USA')"></mg-country>
  <mg-country
    [country]="$any('INTL')"
    [active]="value == 'INTL'"
    (click)="_setValue('INTL')"></mg-country>
</div>
